import React from "react";
import ReactGA from "react-ga";
import styles from "../../styles/presentational/suggestedCharity.css";

export class SuggestedCharity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let selectedEINs = this.props.selectedCharities.map((charity) => {
      return charity.ein;
    });
    return (
      <div
        className={
          styles.main + (this.props.fixedPosition ? " " + styles.fixed : "")
        }
      >
        <div
          className={styles.charity}
          key={this.props.charity.ein}
          onClick={() => {
            ReactGA.event({
              category: "User Action",
              action: "Clicked Open Charity " + this.props.charity.ein,
              label: "/Spend/Presentational/SuggestedCharity",
            });
            this.props.onViewCharity(this.props.charity);
          }}
        >
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{
              __html: this.props.markup,
            }}
          />
          <div className={styles.commands}>
            {selectedEINs.indexOf(this.props.charity.ein) == -1 ? (
              this.props.additionalCharityCount >=
              this.props.selectedCharities.length ? (
                <button
                  className={styles.button + " " + styles.select}
                  onClick={(event) => {
                    event.stopPropagation();
                    ReactGA.event({
                      category: "User Action",
                      action: "Clicked Select Charity",
                      label: "/Spend/Presentational/SuggestedCharity",
                    });
                    this.props.onSelectCharity(this.props.charity);
                  }}
                >
                  {this.props.dictionary.suggested_charity_selector_select}
                </button>
              ) : null
            ) : (
              <button
                className={styles.button + " " + styles.unselect}
                onClick={(event) => {
                  event.stopPropagation();
                  ReactGA.event({
                    category: "User Action",
                    action: "Clicked Remove Charity",
                    label: "/Spend/Presentational/SuggestedCharity",
                  });
                  this.props.onRemoveCharity(this.props.charity.ein);
                }}
              >
                {this.props.dictionary.suggested_charity_selector_unselect}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
